// import Service from '@/service/index.js';
export default {
  components: {
  },
  props: {
    previewContract: {
      type: Object,
      default: {}
    },
    closeBtn: {
      type: Boolean,
      default: false
    },
    projectSubType: {
      type: String,
      default: ''
    },
    massifType: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      id: '',
      dialogFormVisible: true,
      citytitle: ''
    };
  },
  computed: {
    previewPageContract () {
      if (this.previewContract && this.previewContract.assetsInfo) {
        return JSON.parse(this.previewContract.assetsInfo);
      }
    }
  },
  methods: {
    handleScroll () {
      const scrollTop = this.$refs.box.scrollTop; // 获取滑动距离
      if (scrollTop >= 1600) {
        this.$emit('enabledBtn');
      }
    },
    getSummaries (param) {
      const sumFlag = ['area'];
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        } else {
          if (sumFlag.includes(column.property)) {
            let sum = 0;
            data.forEach(item => {
              sum += Number(item[column.property]);
            });
            sums[index] = sum;
          } else {
            sums[index] = '';
          }
        }
      });
      return sums;
    },
    dialogFormClick () {
      this.$emit('dialogFormClick');
    }
  }
};
